import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "../../../constant/storages";
import { errMsg } from "../../../text_control/error-msg";
import { BTN } from "../../../text_control/text_button";
import { _getStorage, _setStorage } from "../../../utils/local-storage";
import { ApiserviceService } from "../../../httpservice/apiservice.service";

@Component({
  selector: "app-unlock-abb",
  templateUrl: "./unlock-abb.component.html",
  styleUrls: ["./unlock-abb.component.scss"],
})
export class UnlockAbbComponent implements OnInit {
  Active = 4;
  receiptNo = "";
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  constructor(
    public router: Router,
    private apiService: ApiserviceService,
    public loadingController: LoadingController,
    private alert: AlertController
  ) {}

  ngOnInit() {}
  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
    }
  }
  checkCaseID(event) {
    this.receiptNo = event.target.value.match(/[0-9-]*/)[0];
  }

  async searchUnlockAbb() {
    const url =
      "https://uat-etax-apims.central.co.th/nonprd-etax001/back-office-";

    if (!this.receiptNo) {
      this.ErrorMsg(errMsg.errorReceiptNo);
      return;
    }
    const req = {
      storeBu: this.userBu,
      storeLoc: this.userLoc,
      userId: this.userID,
      receiptNo: this.receiptNo,
      isTpNo: false,
    };
    console.log("====== req search error log =======", req);
    this.apiService
      ._post(this.apiService.apiUrl + this.apiService.searchUnlock, req)
      .then((res) => {
        console.log("====== res search error log =======", res);
        try {
          if (res.statusCode === 200) {
            _setStorage(STORAGE.DATA_UNLOCK_ABB, res.data);
            this.router.navigate(["/backoffice/unlock-abb-detail"]);
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        } catch (error) {
          this.ErrorMsg(errMsg.error);
        }
      });
  }
  async ErrorMsg(message: string) {
    let alert = await this.alert.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
